module.exports = "/_next/static/images/australia-c934af2a787d3e8785736e1bb3636901.svg";